import { useSelector } from "react-redux";
import { RootState } from "../../state";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

/**
 * Loader layer linked to the redux state (backdropLoader)
 */
export const BackdropLoader = () => {
  const backdropLoaderData = useSelector(
    (state: RootState) => state.backdropLoader,
  );

  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
      open={backdropLoaderData.open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default BackdropLoader;
